import React from "react";
import PropTypes from "prop-types";
import { MDBTooltip } from "mdb-react-ui-kit";
import orderAheadIcon from "../../assets/svgviewer-output.svg";
import styles from "./OrderAheadEnabledBadge.module.scss";

export function isCafeOrderAheadEnabled(cafe) {
  if (!cafe) {
    return false;
  }
  if (cafe.orderAheadEnabled === true) {
    return true;
  }
  if (cafe.orderAhead?.enabled === true) {
    return true;
  }
  return (
    cafe.orderAhead?.status === "approved" && cafe.orderAhead?.enabled !== false
  );
}

function OrderAheadEnabledBadge({ cafe, className }) {
  if (!isCafeOrderAheadEnabled(cafe)) {
    return null;
  }

  return (
    <MDBTooltip tag="span" title="Order Ahead is enabled for this café">
      <span
        className={`${styles.badge} ${className || ""}`}
        aria-label="Order Ahead enabled"
      >
        <img
          src={orderAheadIcon}
          alt=""
          aria-hidden="true"
          className={styles.icon}
        />
        <span className={styles.label}>Order Ahead</span>
      </span>
    </MDBTooltip>
  );
}

OrderAheadEnabledBadge.propTypes = {
  cafe: PropTypes.object,
  className: PropTypes.string,
};

OrderAheadEnabledBadge.defaultProps = {
  cafe: null,
  className: "",
};

export default OrderAheadEnabledBadge;
